
import { defineComponent, toRefs, PropType, computed } from 'vue'
import { Campaigns } from '@/lib/campaigns'
import { Campaign } from '@/types'
import { useI18n } from 'vue-i18n'

type LabelClass = 'ncgr-label--warning' | 'ncgr-label--success' | 'ncgr-label--danger'

export default defineComponent({
  props: {
    campaign: {
      type: Object as PropType<Campaign>,
      required: true
    }
  },
  setup (props) {
    const { t } = useI18n()
    const { campaign } = toRefs(props)

    const state = computed(() => Campaigns.status(campaign.value))
    const className = computed<LabelClass>(() => {
      switch (state.value) {
        case 'unstarted':
          return 'ncgr-label--warning'
        case 'started':
          return 'ncgr-label--success'
        case 'ended':
        case 'disabled':
          return 'ncgr-label--danger'
        default:
          return 'ncgr-label--success'
      }
    })

    return { t, state, className }
  }
})
